var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.613,
    height: 18.3,
    viewBox: "0 0 16.613 18.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 16.613,
    height: 18.3,
    fill: "#A5A5A5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M15.9,3.373H12.4V2.4A2.406,2.406,0,0,0,9.993,0H6.62a2.406,2.406,0,0,0-2.4,2.4v.969H.717a.717.717,0,0,0,0,1.434h.97V15.9a2.406,2.406,0,0,0,2.4,2.4h8.433a2.406,2.406,0,0,0,2.4-2.4V4.808H15.9a.717.717,0,0,0,0-1.434M5.649,2.4a.971.971,0,0,1,.971-.97H9.993a.971.971,0,0,1,.97.97v.969H5.649ZM13.493,15.9a.972.972,0,0,1-.97.97H4.09a.972.972,0,0,1-.971-.97V4.808H13.493Z",
    transform: "translate(0 0)",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M7.717,9A.717.717,0,0,0,7,9.717v5.061a.717.717,0,0,0,1.434,0V9.717A.717.717,0,0,0,7.717,9",
    transform: "translate(-1.097 -1.41)",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M11.717,9A.717.717,0,0,0,11,9.717v5.061a.717.717,0,0,0,1.434,0V9.717A.717.717,0,0,0,11.717,9",
    transform: "translate(-1.724 -1.41)",
    fill: "#A5A5A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ff02f330fb064174395fe4bfe67b4858.svg";
export { ForwardRef as ReactComponent };